import { InjectionKey } from 'vue';
// 注文問い合わせ件数取得関数を呼び出すkey設定
const countOrderQuotableKey: InjectionKey<() => void> = Symbol('countOrderQuotable');
export default countOrderQuotableKey;
